import { CHATBOX } from "../client";
/**
 * Set the font size for the chatbox
 */
export function resizeChatbox() {
  const chatContainerBox = document.getElementById("client_chatcontainer");
  const clockBox = document.getElementById("client_clock");
  const trackstatusBox = document.getElementById("client_trackstatus");

  const gameHeight = document.getElementById("client_background")!.offsetHeight;

  chatContainerBox.style.fontSize = `${(gameHeight * 0.0521).toFixed(1)}px`;
  clockBox.style.fontSize = `${(gameHeight * 0.0521).toFixed(1)}px`;
  trackstatusBox.style.fontSize = `${(gameHeight * 0.0521).toFixed(1)}px`;

  const trackstatus = <HTMLMarqueeElement>(
    document.getElementById("client_trackstatustext")
  );
  // Shaving a pixel keeps the marquee from wrapping, but when the element is
  // hidden (the Modern layout swaps it for the now-playing ticker) offsetWidth
  // is 0, and `width: -1px` is invalid: the browser drops the declaration and
  // logs a parse error. Only apply it when the element is actually laid out.
  if (trackstatus.offsetWidth > 1) {
    trackstatus.style.width = `${trackstatus.offsetWidth - 1}px`;
  }

  //name spacing
  const namePlate = document.getElementById("client_name");
  if (CHATBOX == "aa" && namePlate.innerText.length < 5) {
    namePlate.style.letterSpacing = "0.2em";
  } else {
    namePlate.style.letterSpacing = "normal";
  }

  //clock
  const now = new Date();
  let weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  document.getElementById("client_clock_month")!.innerText =
    month[now.getMonth()];
  if (CHATBOX == "acww") {
    weekday = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    document.getElementById("client_clock_weekday")!.innerText =
      weekday[now.getDay()];
    document.getElementById("client_clock_date")!.innerText =
      now.getDay() + "/" + now.getMonth();
    document.getElementById("client_clock_time")!.innerText =
      now.getHours() + ":" + now.getMinutes();
  } else if (CHATBOX == "key") {
    weekday = ["Sun.", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat."];
    document.getElementById("client_clock_weekday")!.innerText =
      weekday[now.getDay()];
    document.getElementById("client_clock_date")!.innerText = String(
      now.getDate(),
    );
  }
}
window.resizeChatbox = resizeChatbox;
